<template>
    <div class="container my-5">
        <div class="d-flex flex-wrap justify-content-center">
            <div v-for="(permiso, x) in Permisos" :key="x">
                <router-link :to="{ name: permiso.clave}" custom v-slot="{ navigate, href, route   }">
                <!--<a :href="href" @click="navigate" >-->
                    <!-- {{permiso}} -->
                    <!-- {{permiso.clave}} -->
                    <div class="card-menu" @click="recargarPage(route)" style="cursor:pointer" v-show="permisoTemporal(permiso.clave, usuario.esUsuarioIntegrado)"> 
                        <div class="container-card">
                            <div class="d-flex justify-content-center">                                
                                <img style="width: 90px;" :src="require(`@/assets/img/iconSubsistemas/${permiso.clave}.svg`)" 
                                :alt="permiso.descripcionFuncion">
                            </div>
                            <div class="title-proyecto">
                                <p class="title">{{permiso.descripcionFuncion}}</p>
                                 <!-- <p class="title"> {{permiso.clave}}</p>  -->
                            </div>
                        </div>                         
                    </div>     
                    <!-- {{permiso.clave}}       -->
                <!--</a>-->
                </router-link>
            </div>
            <!-- {{usuario.esUsuarioIntegrado}} -->
        </div>
    </div>
</template> 
<script> 
import mapHelper from '@/store/modules/common/map-helper';
import GenericMixin from '@/mixins/GenericMixin';

export default{
    mixins: [GenericMixin],
    name: 'inical',
    computed:{
        Permisos(){ return this.$store.getters[mapHelper.mapmod.SIAHE_AUTH+mapHelper.mapfn.getPermisosPrincipal]; },
        usuario() {      return this.$store.getters[mapHelper.mapmod.SIAHE_AUTH + mapHelper.mapfn.getUsuario];    },
    },
    methods:{
        async recargarPage(route){
            this.$router.push({ name: route.name });
            //this.$forceUpdate();
            location.reload();  
        },
        /** funcion de prueba de carga de perfiles **/
        async cargarPerfilUser(idsubsistema){
            try{
                let response = await this.$store.dispatch(mapHelper.mapmod.SIAHE_AUTH+mapHelper.mapfn.buscarUsuario,idsubsistema);
            }catch(error){ console.log(error); }
        },
        permisoTemporal(modulo, esIntegrado){
            //console.log('Modulo:', modulo, ' Es Integrado:', esIntegrado)
            // if(modulo=='000002' && !esIntegrado) return false
            // if(modulo=='000003' && !esIntegrado) return false
            return true
        },
    }
}
</script>
<style scoped>
a { color: black; text-decoration: none; }
</style>